
import type { CustomerApi, CustomersDashboardApi } from "@/types/api/customers";
import type { CustomerUI, CustomersKpisUI } from "@/types/ui/customers";

export function mapCustomerApiToUi(apiCustomer: CustomerApi): CustomerUI {
  return {
    id: apiCustomer.id,
    name: apiCustomer.name,
    accountNumber: apiCustomer.accountNumber,
    currency: apiCustomer.currency as "USD" | "EUR" | "GBP" | "CAD" | "AUD",
    outstanding: apiCustomer.outstanding,
    overdue: apiCustomer.overdue,
    creditLimit: apiCustomer.creditLimit,
    dso: apiCustomer.dso ?? 0,
    risk: apiCustomer.risk,
    riskLevelName: apiCustomer.riskLevelName,
    lastPayment: apiCustomer.lastPayment ?? "",
    contact: apiCustomer.contact ?? "",
    phone: apiCustomer.phone ?? "",
    address: apiCustomer.address ?? "",
    paymentTerms: (apiCustomer.paymentTerms as CustomerUI["paymentTerms"]) || "Net 30",
    collectionStrategyId: apiCustomer.collectionStrategyId ?? "",
    collectionStrategyName: apiCustomer.collectionStrategyName,
    creditControllerId: apiCustomer.creditControllerId,
    creditControllerName: apiCustomer.creditControllerName,
    accountManagerId: apiCustomer.accountManagerId,
    accountManagerName: apiCustomer.accountManagerName,
    otherCompaniesCount: apiCustomer.otherCompaniesCount,
  };
}

export function mapDashboardToKpis(dashboard: CustomersDashboardApi): CustomersKpisUI {
  return {
    totalCustomers: dashboard.totalCustomers,
    totalOutstanding: dashboard.totalOutstanding,
    totalOverdue: dashboard.totalOverdue,
    highRiskCount: dashboard.highRiskCount,
  };
}
